import { cn } from '../../../lib/cn'

export interface DotsBottomProps {
  className?: string
}

/**
 * DotsBottom - Dot pattern background with bottom fade
 *
 * Creates a repeating dot pattern that fades from the bottom.
 * Uses theme variables for automatic light/dark mode support.
 *
 * Fixed fadeSize: 0.5
 *
 * @example
 * ```tsx
 * <section className="relative">
 *   <DotsBottom />
 *   <div className="relative z-10">Content here</div>
 * </section>
 * ```
 */
export function DotsBottom({ className }: DotsBottomProps = {}) {
  const fadeSize = 0.5
  const sizeX = `${fadeSize * 100}%`
  const sizeY = `${fadeSize * 100 * 0.85}%` // Slightly shorter vertically
  const maskGradient = `radial-gradient(ellipse ${sizeX} ${sizeY} at 50% 100%, #000 45%, transparent 100%)`

  return (
    <div
      className={cn('absolute inset-0 z-0', className)}
      style={{
        backgroundImage: `radial-gradient(circle, var(--border) 1px, transparent 1px)`,
        backgroundSize: '24px 24px',
        maskImage: maskGradient,
        WebkitMaskImage: maskGradient,
      }}
    />
  )
}
